import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from '../../../components/Seo';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterMedium } from '../../../components/FooterMedium';

import {
  Screen1,
  Marathon,
  Decide,
  Gifts,
  Program,
  Timetable,
  ResultsAfter,
  ResultsStudents,
  RevsText,
  Speakers,
  Neuro,
  Help,
  Advance,
  Reg,
} from '../../../components/LandingTemplates/marathon_razvitija_mozga_i_navykov_obuchenija-2025';

const TITLE = 'Марафон развития мозга и навыков обучения';
const DESCRIPTION =
  'Попробуйте нейроупражнения, мнемотехники, майнд-карты, скорочтение и многое другое на своем опыте | Центр образовательных технологий Advance';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({
  widgetFree = <GetCourseWidget hash={'68c5daf61d432f91ed25532cdbbb14f63e293336'} id={'1369764'} />,
  widgetFreeHorizontal = <GetCourseWidget hash={'304794195541664a30734b3f6ed9e82adfac4807'} id={'1369765'} />,
}) => {
  return (
    <DefaultLayout>
      <YandexMetrika />
      <MailRu />
      <TikTok />
      <VKPixel />
      <AdvCake />

      <main>
        <Screen1 id={'im_2025'} widgetFree={widgetFree} />
        <Marathon />
        <Decide />
        <Gifts widgetFree={widgetFreeHorizontal} />
        <Program />
        <Timetable id={'im_2025'} widgetFree={widgetFreeHorizontal} />
        <ResultsAfter widgetFree={widgetFreeHorizontal} />
        <ResultsStudents />
        <RevsText />
        <Speakers />
        <Neuro widgetFree={widgetFree} />
        <Help />
        <Advance />
        <Reg id={'im_2025'} widgetFree={widgetFree} />
      </main>

      <FooterMedium />
    </DefaultLayout>
  );
};
export default Page;
